import { every } from 'lodash';

export function getCartCount({ items = [] }) {
  return items.reduce((acc, curr) => {
    return acc + curr.quantity;
  }, 0);
}

export function canCheckout(cart, validatedCart = {}) {
  return (
    Boolean(cart.items.length) && Boolean(validatedCart.items?.length) && every(validatedCart.items, 'availableForSale')
  );
}

// Preselection rules shared by every checkout surface (shopper cart, store checkout, self-checkout).
// When the store's autoSelectCheckoutDefaults setting is on, fall back to the account's default (or
// first) option. When it is off, only a field with exactly one option is filled in for the shopper —
// everything else must be chosen deliberately, which is what keeps funding and inventory accurate.
export function getPreselectedAccount(accounts, autoSelect) {
  const options = accounts ?? [];
  if (autoSelect) {
    return options[0] ?? null;
  }
  return options.length === 1 ? options[0] : null;
}

export function getPreselectedFund(funds, autoSelect) {
  const options = funds ?? [];
  if (autoSelect) {
    return options.find((f) => f.default) ?? options[0] ?? null;
  }
  return options.length === 1 ? options[0] : null;
}

export function getPreselectedLocation(deliveryLocations, autoSelect) {
  const options = deliveryLocations ?? [];
  if (autoSelect) {
    return options.find((loc) => loc.default) ?? options[0] ?? null;
  }
  return options.length === 1 ? options[0] : null;
}

// The detailed account lags a freshly switched cart account by one render while Apollo refetches;
// using the mismatched one would preselect the previous account's fund and charge the wrong one.
export function getConfirmedAccount(detailedAccount, cartAccount) {
  if (!detailedAccount?._id || !cartAccount?._id) {
    return null;
  }
  return detailedAccount._id === cartAccount._id ? detailedAccount : null;
}

export function canPlaceOrder(cart, validatedCart = {}, isStoreCheckout, shopper) {
  if (!cart.deliveryLocation?.id) {
    return false;
  }

  const validation =
    Boolean(cart.items?.length) &&
    Boolean(validatedCart.account?._id) &&
    Boolean(validatedCart.fund?.id) &&
    Boolean(cart.receivingType) &&
    validatedCart.isFundValid;

  if (isStoreCheckout) {
    return validation && Boolean(shopper?.userId);
  }

  return validation;
}
